import { DeliveryNoteReplyDto } from '@api';
import { DELIVERY_NOTE_REPLY_STATUS } from '@app/mock/data/delivery-note-reply-status';
import { DELIVERY_NOTES } from '@app/mock/data/delivery_notes';

const baseDeliveryNoteReply: DeliveryNoteReplyDto = {
  id: 0,
  createdBy: null,
  createdById: 0,
  created: null,
  lastChange: null,

  deliveryDateFrom: '',
  deliveryDateTo: '',

  operatingTimes: [
    {
      id: 0,
      deliveryNoteReply: null,
      deliveryNoteReplyId: null,
      created: '2025-10-01T00:00:00Z',
      lastChange: '2025-10-01T00:00:00Z',
      from: '2025-10-01T08:00:00Z',
      to: '2025-10-01T16:00:00Z',
    },
  ],
  waitingTimeInHours: null,
  waitingReason: null,

  dirtyPlateCount: 0,
  damagedPlateCount: 0,
  unloadedOtherVehicleCount: 0,

  hasImages: false,
  remarks: null,

  customerLiabilityName: null,
  customerLiabilitySignature: null,
  customerLiabilitySignatureId: null,

  contactPersonName: null,
  contactPersonPhonenumber: null,
  contactPersonPhonenumberMobile: null,

  customerSignature: null,
  customerSignatureId: null,

  driverSignature: {
    id: 0,
    created: null,
    lastChange: null,
    signatureData: 'ABC',
  },
  driverSignatureId: 0,

  positions: [],

  deliveryNote: DELIVERY_NOTES[0],
  deliveryNoteId: DELIVERY_NOTES[0].id ?? 0,

  status: DELIVERY_NOTE_REPLY_STATUS[0],
  statusId: DELIVERY_NOTE_REPLY_STATUS[0].id ?? 0,
};

export const DELIVERY_NOTE_REPLIES: DeliveryNoteReplyDto[] = [
  {
    ...baseDeliveryNoteReply,
    id: 1,
  },
];
